// extracted by mini-css-extract-plugin
module.exports = {"grid":"Features-module--grid--2TvOv","gridColumn":"Features-module--grid-column--3Gxra"};